import React from 'react';
import propTypes from 'prop-types';
import RoutableSitecoreLink from '@hedinbil/hedin-ui/dist/utils/RoutableSitecoreLink';

const Card = (props) => {
  const { raised, hover, link, children, className, scaleAnimation, maxWidth, style, onClick } =
    props;
  const classes = () => {
    let usedClasses = 'card';
    if (raised) {
      usedClasses += ' card__raised';
    }
    if (hover) {
      usedClasses += ' card__hover';
    }
    if (link) {
      usedClasses += ' card__link';
    }
    if (scaleAnimation) {
      usedClasses += ' card__scale-anim';
    }
    if (className) {
      usedClasses += ' ' + className;
    }
    return usedClasses;
  };
  let styles = null;

  const newStyles = { ...style };

  if (maxWidth) {
    styles = { ...newStyles, maxWidth: maxWidth + 'px' };
  }

  if (link) {
    return (
      <RoutableSitecoreLink
        onClick={onClick}
        className={classes()}
        field={link}
        style={newStyles ? newStyles : null}
      >
        {children}
      </RoutableSitecoreLink>
    );
  }
  return (
    <div className={classes()} style={newStyles ? newStyles : null}>
      {children}
    </div>
  );
};

Card.propTypes = {
  raised: propTypes.bool,
  hover: propTypes.bool,
  img: propTypes.string,
  link: propTypes.object,
  outlined: propTypes.bool,
  maxWidth: propTypes.number,
  scaleAnimation: propTypes.bool,
};

export default Card;
